// extracted by mini-css-extract-plugin
export default {"checkboxGroup":"WorkingDays_checkboxGroup__WNpxg","ant-checkbox-group":"WorkingDays_ant-checkbox-group__5qgwq","ant-checkbox-group-item":"WorkingDays_ant-checkbox-group-item__AF3rp"};